// No persistent queue: reviewed content stays in this mounted Listener until accepted or skipped.
export const collectionFailureMessage = (status, detail) => {
    if (status === 422) {
        const entries = Array.isArray(detail) ? detail : [];
        if (entries.some(entry => /conversation_id is required when turn_id is provided/.test(entry?.msg || ""))) {
            return "The reviewed turn is missing its conversation ID (HTTP 422).";
        }
        // FastAPI validation details also contain submitted input; never display those values.
        const allowedFields = new Set(["conversation_id", "turn_id", "task_id", "source_language",
            "target_language", "source_dialect", "target_dialect", "source_text", "user_transcript_final",
            "user_output_final", "input_modality", "started_at", "duration_ms", "consent_id",
            "participant_id", "metadata", "app_id", "app_version", "game_id"]);
        const fields = [...new Set(entries.flatMap(entry => entry?.loc || []).filter(field => allowedFields.has(field)))];
        return `Collection request validation failed (HTTP 422)${fields.length ? "; check " + fields.join(", ") : ""}.`;
    }
    if ([401, 403, 409, 410].includes(status)) {
        return `Collection rejected the request (HTTP ${status}). Review Data & consent before retrying.`;
    }
    if (status >= 500) return `The research collection service is temporarily unavailable (HTTP ${status}).`;
    return `Collection request failed (HTTP ${status}).`;
};

export const listenerContributionFailureMessage = (error) => (
    "Research contribution could not be confirmed. "
    + (error?.message || "The collection service did not confirm the request.")
    + " Your reviewed text is still on screen. Retry to confirm its status, or uncheck contribution to continue without another research request."
);

export const submitReviewedListenerContribution = async (pendingRef, payload, submit) => {
    // Duration changes while the user retries, but the committed request must not.
    const review = { ...payload };
    delete review.duration_ms;
    delete review.submitted_at;
    const fingerprint = JSON.stringify(review);
    if (pendingRef.current && pendingRef.current.fingerprint !== fingerprint) {
        throw new Error("An earlier request has an unconfirmed outcome. Retry the unchanged review before editing it.");
    }
    if (!pendingRef.current) {
        pendingRef.current = { fingerprint, payload: JSON.parse(JSON.stringify(payload)) };
    }
    try {
        return await submit(pendingRef.current.payload);
    } catch (error) {
        // These responses definitely reject this body before a record is committed.
        // A timeout, 5xx, or idempotency conflict can have an uncertain outcome.
        if ([400, 401, 403, 404, 410, 422].includes(error?.collectionStatus)) pendingRef.current = null;
        throw error;
    }
};
